import { render, staticRenderFns } from "./JoinedGroup.vue?vue&type=template&id=29c636d2&scoped=true"
import script from "./JoinedGroup.vue?vue&type=script&lang=js"
export * from "./JoinedGroup.vue?vue&type=script&lang=js"
import style0 from "./JoinedGroup.vue?vue&type=style&index=0&id=29c636d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c636d2",
  null
  
)

export default component.exports